import { useMutation } from '@tanstack/react-query';
import { aiApi, AISummaryResponse } from '@/api/ai-api';

export interface GenerateSummaryInput {
  medicalRecordId: string;
  patientId: string;
  doctorId?: string;
  appointmentId?: string;
}

export function useAISummary() {
  return useMutation<AISummaryResponse, Error, GenerateSummaryInput>({
    mutationFn: (data: GenerateSummaryInput) => aiApi.generateSummary(data),
  });
}